'CustomSpecList'.list()
'Custom Specs'.title()
'Back'.action({act: 'cancel'})
'Add'.action({act: 'add'})
'CustomSpec'.datatype()
'name'.field({key: true})
'status'.field()
'Edit'.action({place: 'row', act: 'edit'})
'Trash'.action({place: 'row', act: 'trash'})
'CustomSpecMaint.js'.maintSpecname()

